/**
 * TODO: 
 * - add onloadscreen
 * - replace light with spheres (maybe) + sprite material
 */

import * as THREE from "three";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import pathToModel from '../../assets/models/garden.glb';
import { coloursToArray } from '../../utils';

export default class SceneController {
    constructor(domElem) {
        this.domElem = domElem;
        this.scene = new THREE.Scene();
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.startTime = Date.now();
    }

    setup() {
        this.colourArr = (0, coloursToArray)('https://coolors.co/0a191f-dad2d8-0f8b8d-ec9a29-a8201a');
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.domElem.appendChild(this.renderer.domElement);

        this.disposed = false;
        this.scene.background = this.colourArr[0];
        // this.scene.fog = new THREE.Fog(this.colourArr[2], 1, 50);  

        this.setupCamera();
        this.setupLight();
        this.loadModels();
        this.setupControls();
        this.setupGeometry();
    }

    setupCamera() {
        let VIEW_ANGLE = 70;
        let ASPECT_RATIO = window.innerWidth / window.innerHeight;
        let NEAR_PLANE = 0.01;
        let FAR_PLANE = 100;

        this.camera = new THREE.PerspectiveCamera(VIEW_ANGLE, ASPECT_RATIO, NEAR_PLANE, FAR_PLANE);
        this.camera.position.set(-3, -22, 17);
        this.camera.lookAt(new THREE.Vector3(0, 0, 0));
    }

    setupLight() {
        let hemiLight = new THREE.HemisphereLight(this.colourArr[4], this.colourArr[0], 1);
        hemiLight.position.set(0, 0.5, -1);
        this.scene.add(hemiLight);

        let dirLight = new THREE.DirectionalLight(this.colourArr[4], 5);
        this.scene.add(dirLight);

        //lights to animate
        let sphere = new THREE.SphereBufferGeometry(0.15, 8, 8);
        this.light1 = new THREE.PointLight(0xff0040, 2, 50);
        this.light1.add(new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: 0xA3D2FD })));
        this.scene.add(this.light1);

        this.light2 = new THREE.PointLight(0x0040ff, 2, 50);
        this.light2.add(new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: 0x23D9D1 })));
        this.scene.add(this.light2);

        this.light3 = new THREE.PointLight(0x80ff80, 2, 50);
        this.light3.add(new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: 0xA3D2FD })));
        this.scene.add(this.light3);

        this.light4 = new THREE.PointLight(0xA3D2FD, 2, 50);
        this.light4.add(new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: 0xA3D2FD })));
        this.scene.add(this.light4);

        this.light5 = new THREE.PointLight(0xA3D2FD, 2, 50);
        this.light5.add(new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: 0xA3D2FD })));
        this.scene.add(this.light5);

        this.light6 = new THREE.PointLight(0x80ff80, 2, 50);
        this.light6.add(new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: 0x23D9D1 })));
        this.scene.add(this.light6);

        this.light7 = new THREE.PointLight(0x80ff80, 2, 50);
        this.light7.add(new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: 0xA3D2FD })));
        this.scene.add(this.light7);
    }

    setupControls() {
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.zoomSpeed = 1.2;
        this.controls.panSpeed = 0.8;
        this.controls.enableZoom = true;
        this.controls.enablePan = false;
        this.controls.enableDamping = false;
        this.controls.dampingFactor = 0.3;
        this.controls.maxDistance = 70;
        this.controls.minDistance = 5;
    }

    setupShaderMaterial() {
        this.uniforms = {
            u_resolution: { type: "v2", value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
            u_time: { type: "f", value: 0 }
            // u_color0:     { type: "v3", value: new THREE.Color( 0xff0000 ) },
            // u_color1:     { type: "v3", value: new THREE.Color( 0x6fa8dc ) },
        };

        let material = new THREE.ShaderMaterial({
            uniforms: this.uniforms,
            vertexShader: `
                varying vec3 vNormal;
                varying vec2 vUv; 
            
                void main()
                {
                    vNormal = normal;
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0 );
                }
            `,
            fragmentShader: `
                precision mediump float;

                uniform float u_time;
                uniform vec2 u_resolution;

                varying vec2 vUv;
                varying vec3 vNormal;

                const float fluid_speed = 200.0;
                const float color_intensity = 0.5;

                float rand(vec2 co)
                {
                    return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);
                }

                void main()
                {
                    vec2 pos = vUv * (gl_FragCoord.xy/u_resolution);

                    for(int i=1; i<45; i++)
                    {
                        vec2 newPos = pos + u_time * 0.02;
                        newPos.x+=0.6/float(i)*sin(float(i)*pos.y+u_time/fluid_speed+0.3*float(i)) + 0.5;
                        newPos.y+=0.6/float(i)*sin(float(i)*pos.x+u_time/fluid_speed+0.3*float(i+10)) - 0.5;
                        pos = newPos;
                    }

                    vec3 n = vNormal;
                    vec3 col = vec3(color_intensity * sin(0.5 * pos.x) + n.x, 
                                    color_intensity * sin(pos.x + pos.y),
                                    color_intensity * sin(1.0 * pos.y) + n.z);
                    //gl_FragColor=vec4(col, 1.0);
                    gl_FragColor=vec4(col * vNormal, 1.0);
                }
            `
        });
        return material;
    }

    loadModels() {
        let material = this.setupShaderMaterial();
        const gltfLoader = new GLTFLoader();
        gltfLoader.load(pathToModel, (gltf) => {
            this.root = gltf.scene;
            this.root.position.set(-50, -100, 50);
            this.root.scale.set(0.5, 0.5, 0.5);
            this.root.traverse(node => {
                if (node.isMesh) {
                    node.material = material;
                }
            });
            this.scene.add(this.root);
        });
    }

    setupGeometry() {
        let geometry = new THREE.IcosahedronGeometry(3, 0);
        let material = new THREE.MeshPhongMaterial({
            color: 0x020b13,
            shininess: 100
        });
        let mesh = new THREE.Mesh(geometry, material);
        this.scene.add(mesh);
    }

    orbitCamera(rotSpeed) {
        let x = this.camera.position.x;
        let z = this.camera.position.z;

        this.camera.position.x = x * Math.cos(rotSpeed) + z * Math.sin(rotSpeed);
        this.camera.position.z = z * Math.cos(rotSpeed) - x * Math.sin(rotSpeed);

        this.camera.lookAt(new THREE.Vector3(0, 0, 0));
    }

    updateSceneSubjects(time) {
        this.light1.position.x = Math.sin(0.001 * time) * 4;
        this.light1.position.y = Math.cos(0.001 * time) * 4;
        this.light1.position.z = Math.cos(0.001 * time) * 4;

        this.light2.position.x = Math.cos(0.001 * time) * 5;
        this.light2.position.y = Math.sin(0.001 * time) * 5;
        this.light2.position.z = Math.sin(0.001 * time) * -5;

        this.light3.position.x = Math.sin(0.001 * time) * -4;
        this.light3.position.y = Math.cos(0.001 * time) * 4;
        this.light3.position.z = Math.sin(0.001 * time) * 4;

        this.light4.position.x = Math.sin(0.001 * time) * -5;
        this.light4.position.y = Math.cos(0.001 * time) * -5;
        this.light4.position.z = Math.sin(0.001 * time) * 5;

        this.light5.position.x = Math.sin(0.001 * time) * 5;
        this.light5.position.y = Math.cos(0.001 * time) * -5;
        this.light5.position.z = Math.sin(0.001 * time) * 5;

        this.light6.position.x = Math.sin(0.001 * time) * 3;
        this.light6.position.y = Math.cos(0.001 * time) * 3;
        this.light6.position.z = Math.cos(0.001 * time) * -3;

        this.light7.position.x = Math.sin(0.001 * time) * -4;
        this.light7.position.y = Math.cos(0.001 * time) * 4;
        this.light7.position.z = Math.sin(0.001 * time) * -4;
    }

    update() {
        if (this.disposed) return;
        if (this.camera) this.orbitCamera(0.001);
        if (this.uniforms) this.uniforms['u_time'].value = 0.001 * (Date.now() - this.startTime);
        this.updateSceneSubjects(Date.now() - this.startTime);
        this.renderer.render(this.scene, this.camera);
    }

    onWindowResize() {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    dispose() {
        this.disposed = true;
        this.scene.dispose();
        this.renderer.dispose();
    };
}